// Service-URL suggestions for the provider-template form.
// Auto-fill is host-aware: known hosts get their real per-service layout,
// unknown hosts fall back to "everything is the base root" (blank = base).

export interface TemplateUrlSuggestion {
  embeddingUrl: string
  rerankUrl: string
  chatUrl: string
  modelsUrl: string
}

function originOf(baseUrl: string): string | null {
  try {
    const u = new URL(baseUrl.trim())
    return `${u.protocol}//${u.host}`
  } catch {
    return null
  }
}

/**
 * Suggest per-service URLs for a base URL. DeepInfra splits services
 * across two roots (OpenAI-compatible vs native inference); every other
 * host is assumed uniform (all = base).
 */
export function suggestTemplateUrls(baseUrl: string): TemplateUrlSuggestion {
  const base = baseUrl.trim()
  const origin = originOf(base)
  if (origin) {
    try {
      if (new URL(base).hostname.endsWith('deepinfra.com')) {
        return {
          // OpenAI-compatible root — the app appends /embeddings, /models, /chat/completions.
          embeddingUrl: base,
          // Native inference API — full template, used as-is after substitution.
          rerankUrl: `${origin}/v1/inference/{model}`,
          chatUrl: base,
          modelsUrl: base,
        }
      }
    } catch {
      /* fall through to uniform */
    }
  }
  return { embeddingUrl: base, rerankUrl: base, chatUrl: base, modelsUrl: base }
}

/** Append a `{model}` variable to a URL field value (slash-aware). */
export function appendModelVariable(value: string): string {
  const trimmed = value.trim().replace(/\/+$/, '')
  return `${trimmed}/{model}`
}
